var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateEway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00122 2.10688C1.08803 1.73792 1.48304 1 2.36854 1H9.72604C10.1384 1 10.9762 1.22138 11.0283 2.10688V8.48772M11.0283 8.48772V12.0688C11.0717 13.154 11.6533 15.1941 13.6327 14.6732C14.0016 14.543 14.7917 14.0091 15 12.9152V9.98527C14.9783 9.52949 14.6745 8.5919 13.6327 8.48772H11.0283Z",
    stroke: "#2E77D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6794 14.1522H3.41031C2.58557 14.1088 0.949126 13.6053 1.00121 11.9385V1.97656",
    stroke: "#2E77D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1499 7.05469H8.81453",
    stroke: "#2E77D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1499 9.00781H8.94475",
    stroke: "#2E77D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75427 11.2891H9.0098",
    stroke: "#2E77D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01965 3.27734H5.7543",
    stroke: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateEway);
export default __webpack_public_path__ + "static/media/updateEway.529bd74e4676b7025fdeee371873c2b8.svg";
export { ForwardRef as ReactComponent };